export const golfTimeChartKeys: string[] = [
  "Upload Time",
  "Pose Wait Time",
  "Pose Processing Time",
  "Club Wait Time",
  "Club Processing Time",
  "Visualize Time",
  "Total Time",
];
export const launchTimeChartKeys: string[] = [
  "Upload Time",
  "Wait Time",
  "Processing Time",
  // "Visualize Time",
];
export const athleticsTimeChartKeys: string[] = [
  "Upload Time",
  "Wait Time",
  "Processing Time",
  "Visualize Time",
];

export const timeChartKeysObj: { [key: string]: string[] } = {
  "/m2c-golf-history": golfTimeChartKeys,
  "/m2c-launch-history": launchTimeChartKeys,
  "/m2c-athletics-history": athleticsTimeChartKeys,
  "/user-history": golfTimeChartKeys,
};

export const initialSummaryData: { [key: string]: string } = {
  uploadedBy: "--",
  videoName: "--",
  deviceType: "--",
  camera: "--",
  deviceAngle: "--",
  ISO: "--",
  shutter: "--",
  duration: "--",
  frameRate: "--",
  swingType: "--",
  orientation: "--",
  handedness: "--",
  clubType: "--",
  triggertype: "--",
  role: "--",
  resolution: "--",
  isCameraMoved: "--",
  mobileModel: "--",
  appVersion: "--",
};

export const summaryDataKeys: { [key: string]: string } = {
  uploadedBy: "email",
  videoName: "name",
  deviceType: "name",
  camera: "camera_type",
  deviceAngle: "camera_orientation",
  ISO: "iso",
  shutter: "shutter",
  duration: "duration",
  frameRate: "frame_rate",
  swingType: "swingType",
  orientation: "orientation",
  handedness: "handedness",
  clubType: "clubType",
  triggertype: "trigger_type",
  role: "role",
  resolution: "resolution",
  isCameraMoved: "is_camera_moved",
  mobileModel: "mobileModel",
  appVersion: "appVersion",
};

export const base64ImageArrayForRest: { [position: string]: string }[] = [
  { P1: "" },
  { P2: "" },
  { P3: "" },
  { P4: "" },
  { P5: "" },
  { P6: "" },
  { P7: "" },
  { P8: "" },
  { P9: "" },
  { P10: "" },
];

export const base64ImageArrayForAtheltics: { [position: string]: string }[] = [
  { 10: "" },
  { 20: "" },
  { 30: "" },
  { 40: "" },
  { 50: "" },
  { 60: "" },
  { 70: "" },
  { 80: "" },
  { 90: "" },
  { 100: "" },
];

export const defaultHighlightsData: { [key: string]: string }[] = [
  {
    key: "Start_to_impact_time",
    title: "Start to Impact",
    unit: "sec",
    value: "--",
    variant: "blue",
  },
  {
    key: "new_tempo",
    title: "Tempo",
    unit: "",
    value: "--",
    variant: "yellow",
  },
  {
    key: "Max_Hand_Speed",
    title: "Max. Hand Speed",
    unit: "mph",
    value: "--",
    variant: "green",
  },
  {
    key: "new_backswing_time",
    title: "Backswing",
    unit: "sec",
    value: "--",
    variant: "blue",
  },
  {
    key: "Hand_Path_Back_Swing",
    title: "Handpath BS",
    unit: "cm",
    value: "--",
    variant: "yellow",
  },
  {
    key: "Max_UT_turn",
    title: "Shoulder Turn (P4)",
    unit: "degree",
    value: "--",
    variant: "green",
  },
  {
    key: "new_downswing_time",
    title: "Downswing",
    unit: "sec",
    value: "--",
    variant: "blue",
  },
  {
    key: "Hand_Path_Down_Swing",
    title: "Handpath DS",
    unit: "cm",
    value: "--",
    variant: "yellow",
  },
  {
    key: "Max_Pelvis_Turn",
    title: "Pelvis Turn (P4)",
    unit: "degree",
    value: "--",
    variant: "green",
  },
];

export const defaultLaunchData: { [key: string]: string }[] = [
  {
    key: "club_speed",
    title: "Club Speed",
    unit: "mph",
    value: "--",
    variant: "blue",
  },
  {
    key: "carried_distance",
    title: "Carry",
    unit: "yards",
    value: "--",
    variant: "yellow",
  },
  {
    key: "launch_angle",
    title: "Launch Angle",
    unit: "degree",
    value: "--",
    variant: "green",
  },
  {
    key: "ball_speed",
    title: "Ball Speed",
    unit: "mph",
    value: "--",
    variant: "blue",
  },
  {
    key: "total_distance",
    title: "Total",
    unit: "yards",
    value: "--",
    variant: "yellow",
  },
  {
    key: "dynamic_loft",
    title: "Dynamic Loft",
    unit: "degree",
    value: "--",
    variant: "green",
  },
  { key: "smash_factor", title: "SMA Factor", variant: "blue" },
  {
    key: "spin_rate",
    title: "Spin",
    unit: "rpm",
    value: "--",
    variant: "yellow",
  },
  {
    key: "attack_angle",
    title: "Attack Angle",
    unit: "degree",
    value: "--",
    variant: "green",
  },
];
